import { motion } from "framer-motion";
import { Clock, UserCheck, ShieldCheck, Truck, Zap } from "lucide-react";

const USPS = [
  { icon: Clock, title: "Assistenza H24 7/7", desc: "Sempre disponibili per emergenze edili, riparazioni urgenti e interventi tempestivi in tutta Roma e provincia." },
  { icon: UserCheck, title: "Rapporto Diretto col Cliente", desc: "Nessun intermediario: parli e concordi i dettagli direttamente con Daniele Peluso e i responsabili di cantiere." },
  { icon: ShieldCheck, title: "Operatori Specializzati", desc: "Personale qualificato e certificato per lavori in quota, su ponteggi e interventi ad alto rischio in sicurezza." },
  { icon: Truck, title: "Veicoli di Proprietà", desc: "Parco automezzi ed equipaggiamenti di proprietà per azzerare i tempi di attesa e abbattere i costi di noleggio." },
  { icon: Zap, title: "Piattaforme Aeree di Ogni Dimensione", desc: "Cestelli e piattaforme su autocarro per raggiungere qualsiasi altezza e punto di difficile accesso." },
];

export const WhyUs = () => (
  <section id="perche-noi" className="relative py-24 lg:py-32 bg-[#121215] border-y border-white/5" data-testid="whyus-section">
    <div className="max-w-7xl mx-auto px-4 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mb-14"
      >
        <p className="font-mono-tac text-xs tracking-[0.3em] text-[#FFD500] uppercase font-bold mb-4">[ 02 — La Differenza ]</p>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-white" data-testid="whyus-title">
          Perché scegliere <span className="text-[#FFD500]">Peluso Service</span>
        </h2>
        <p className="mt-4 text-neutral-400 max-w-xl">Affidabilità, mezzi propri e reperibilità continua. Cinque motivi concreti, zero promesse vuote.</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="whyus-grid">
        {USPS.map((u, i) => (
          <motion.div
            key={u.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="group relative bg-[#0A0A0B] border border-white/5 p-7 hover:border-[#FFD500]/40 transition-colors duration-500"
            data-testid={`usp-card-${i}`}
          >
            <span className="absolute top-4 right-5 font-mono-tac text-xs text-white/15 group-hover:text-[#FFD500]/40 transition-colors duration-500">
              /0{i + 1}
            </span>
            <div className="w-12 h-12 flex items-center justify-center bg-[#FFD500] text-black mb-6 transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110">
              <u.icon size={22} strokeWidth={2.2} />
            </div>
            <h3 className="font-display font-bold uppercase text-xl text-white tracking-wide">{u.title}</h3>
            <p className="mt-3 text-sm text-neutral-400 leading-relaxed">{u.desc}</p>
          </motion.div>
        ))}

        <motion.a
          href="#contatti"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="group relative bg-[#FFD500] p-7 flex flex-col justify-between hover:bg-white transition-colors duration-500"
          data-testid="whyus-cta-card"
        >
          <h3 className="font-display font-black uppercase text-2xl text-black leading-tight">
            Hai un'emergenza<br />in corso?
          </h3>
          <p className="mt-4 font-mono-tac text-xs font-bold tracking-[0.2em] uppercase text-black/70 group-hover:text-black transition-colors duration-500">
            Interveniamo subito →
          </p>
        </motion.a>
      </div>
    </div>
  </section>
);
